import { createRoot } from 'react-dom/client';

import App from './App';
import DevelopmentApp, { prepareDevelopment } from './developmentApp';

const container = document.getElementById('root');

if (!container) {
	throw new Error('Root container #root not found');
}

const root = createRoot(container);

/**
 * A standalone dev run has no orchestrator: no Cognito cookie, and a mock
 * worker that has to be listening *before* the first query fires. Both are
 * arranged first, then the app mounts. In production neither branch runs and
 * this is a plain render.
 */
if (import.meta.env.PROD) {
	root.render(<App />);
} else {
	prepareDevelopment()
		.catch((error: unknown) => {
			// Mount anyway. If the worker cannot register, a `.then()` alone
			// leaves a blank page with nothing in the console — the same silent
			// symptom this whole branch exists to avoid. Better a dev app that
			// hits the real gateway and says so than one that never appears.
			// eslint-disable-next-line no-console
			console.error('[dev] prepareDevelopment failed; mounting without mocks', error);
		})
		.finally(() => root.render(<DevelopmentApp />));
}
